/**
 * Unfinished, "coming soon" or sample-data UI shows only on the local dev
 * server. Not REACT_APP_ENV: the production build also carries 'local'.
 */
export const SHOW_PLACEHOLDERS = process.env.NODE_ENV === 'development';

const LocalOnly = ({ children }) => (SHOW_PLACEHOLDERS ? children : null);

export default LocalOnly;
